export function fromToArray(from, to, nbPoints) {
    let result = new Float64Array(nbPoints);
    const jump = (to - from) / (nbPoints - 1);
    for (let i = 0; i < nbPoints; i++) {
        result[i] = from + i * jump;
    }
    return result;
}
//# sourceMappingURL=fromToArray.js.map